export default __webpack_public_path__ + "static/media/digital-card.271a1902.svg";